import React from 'react';
import DokanTablePillTags from '../DokanTablePillTags';
import DokanTableItemShortCategories from './DokanTableItemShortCategories';
import DokanTableItemShortImage from './DokanTableItemShortImage';
import DokanTableItemShortTitle from './DokanTableItemShortTitle';

/* Props: 
productImage= Image <string> , 
productName = product Name  <string>,
isFeatured= featured <boolean>
productCategories = Category <array>,
productType = product Type <string>
*/
const DokanTableItemShortDetails = ({
    productImage,
    productName,
    isFeatured,
    productCategories,
    productType,
    id,
}) => (
    <div className="flex align-start">
        <div className="flex-shrink-0">
            <DokanTableItemShortImage productImage={productImage} alt={productName} />
        </div>
        <div className="pl-20px">
            <DokanTableItemShortTitle productName={productName} isFeatured={isFeatured} />
            <div className="">
                <DokanTableItemShortCategories productCategories={productCategories} id={id} />
            </div>

            <div className="pt-10px">
                <DokanTablePillTags variant="normal">{productType}</DokanTablePillTags>
            </div>
        </div>
    </div>
);

export default DokanTableItemShortDetails;
